import { useState } from "react"
import Modal from "./modal"
const FilterNotes = ({filterDate,clearFilter,showToast})=>{
    const [isModalOpen,setIsModalOpen] = useState(false)
    const [isFilterActive,setIsFilterActive] = useState(false) 
    const openModal = ()=>{
        setIsModalOpen(true)
    }
    const closeModal = () =>{
        setIsModalOpen(false)
    }
    const clearFilterValues = ()=>{
        setIsFilterActive(false)
        clearFilter()
    }
    const renderButton = () =>{
        if(isFilterActive){
            return (<button className="button is-rounded is-large is-danger" id="lol" style={{
                "position": "fixed", 
                "bottom": "15px" ,
                "right": "25px" ,
            }} onClick={clearFilterValues}>
                <span key="times"className="icon is-small">
                    <i className="fas fa-times"></i>
                </span>
            </button> )
        }
        else{
            return (<button className="button is-rounded is-large is-primary" style={{
                "position": "fixed", 
                "bottom": "15px" ,
                "right": "25px" ,
            }} onClick={openModal}>
                <span key="filter" className="icon is-large">
                    <i className="fas fa-filter"></i>
                </span>
            </button>) 
        }
    }

    return(
        <>
            {  renderButton() }
            { isModalOpen ? <Modal showToast={showToast} isActive={isModalOpen} closeModal={closeModal} filterDate={filterDate} activateFilter={setIsFilterActive}/> : <></> }
        </>
    )
}

export default FilterNotes